import { render, staticRenderFns } from "./faqs_en.vue?vue&type=template&id=b9e6d67e&"
import script from "./faqs_en.vue?vue&type=script&lang=js&"
export * from "./faqs_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports